import {Component, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {ETransactionType} from "../../../shared/enums/ETransactionType";
import {GlobalPreferences} from "../../../core/helpers/global-data";
import {AdminControllerService} from "../../../core/api/controllers/admin/admin-controller.service";
import {PaymentHistoryFormFactory} from "./PaymentHistoryFormFactory";
import {PaymentHistoryFormType, PaymentHistoryFormValue} from "./PaymentHistoryFormType";
import {NotificationService} from "../../../core/services/notification.service";

type TransactionHistoryFiltersType = {
  pagination: {page: number; itemsPerPage: number};
  searchBy?: string | null;
  isSuccess?: boolean | null;
  transactionType?: ETransactionType | null;
  invoiceGenerated?: boolean | null;
  startDate?: Date | null;
  endDate?: Date | null;
};

@Component({
  selector: "app-history",
  templateUrl: "./history.component.html",
  styleUrls: ["./history.component.scss"],
})
export class HistoryComponent implements OnInit {
  isLoading = false;
  paymentHistoryForm: FormGroup<PaymentHistoryFormType>;

  filters: TransactionHistoryFiltersType = {pagination: {page: 0, itemsPerPage: 20}};
  defaultFilters: TransactionHistoryFiltersType = {pagination: {page: 0, itemsPerPage: 20}};
  transactions = [];
  totalPages = 0;
  totalCount = 0;
  currentPage = 0;
  readonly skeletonRows = [0, 1, 2, 3, 4];
  transactionType = ETransactionType;
  transactionTypeValues = ["Full Purchase", "Subscription"];

  constructor(
    private adminController: AdminControllerService,
    public global: GlobalPreferences,
    private formFactory: PaymentHistoryFormFactory,
    private notificationService: NotificationService
  ) {
    this.paymentHistoryForm = this.formFactory.create();
  }

  ngOnInit(): void {
    this.handlePaymentHistoryResetForm();
  }

  get hasActiveFilters(): boolean {
    const value = this.paymentHistoryForm.value as PaymentHistoryFormValue;
    return [
      value?.searchBy,
      value?.isSuccess,
      value?.transactionType,
      value?.invoiceGenerated,
      value?.dateTimeInterval?.startDate,
      value?.dateTimeInterval?.endDate,
    ].some((filter) => filter !== null && filter !== undefined && filter !== "");
  }

  trackByTransaction(index: number): number {
    return index;
  }

  handlePaymentHistoryFilters() {
    this.currentPage = 0;
    const formValue = this.paymentHistoryForm.value as PaymentHistoryFormValue;
    const {dateTimeInterval, ...formFilters} = formValue;
    this.filters = {
      ...this.filters,
      pagination: {...this.filters.pagination, page: 0},
      ...formFilters,
      startDate: dateTimeInterval?.startDate ?? null,
      endDate: dateTimeInterval?.endDate ?? null,
    };

    this.fetchPaymentHistory();
  }

  handlePaymentHistoryResetForm() {
    this.paymentHistoryForm.reset();
    this.filters = {
      ...this.defaultFilters,
      pagination: {...this.defaultFilters.pagination}
    };
    this.currentPage = 0;
    this.fetchPaymentHistory();
  }

  fetchPaymentHistory() {
    this.isLoading = true;
    const gmtOffset = this.global.getTimezoneOffset();

    this.adminController
      .getPaymentHistory({ ...this.filters, gmtOffset })
      .subscribe({
        next: ({data, totalCount}: any) => {
          this.transactions = data;
          this.totalCount = totalCount ?? 0;
          this.totalPages = Math.ceil(totalCount / this.filters.pagination.itemsPerPage);
          this.isLoading = false;
        },
        error: error => {
          this.notificationService.error(error);
          this.transactions = [];
          this.totalCount = 0;
          this.totalPages = 0;
          this.isLoading = false;
        }
      });
  }

  handlePaymentHistoryPageSelect(page) {
    this.filters.pagination = {
      ...this.filters.pagination,
      page,
    };

    this.fetchPaymentHistory();
  }

  handlePaymentHistoryPageChange(page) {
    this.currentPage = page;
    this.handlePaymentHistoryPageSelect(page);
  }
}
